// public/js/modules/auth.js

import { getAuth, GoogleAuthProvider, FacebookAuthProvider, OAuthProvider, EmailAuthProvider, signInWithPopup, signInWithRedirect, getRedirectResult, signInWithEmailAndPassword, createUserWithEmailAndPassword, signOut, sendEmailVerification, applyActionCode, confirmPasswordReset, verifyPasswordResetCode } from "https://www.gstatic.com/firebasejs/9.23.0/firebase-auth.js";
import { httpsCallable } from 'https://www.gstatic.com/firebasejs/9.23.0/firebase-functions.js';
import { getFunctions } from 'https://www.gstatic.com/firebasejs/9.23.0/firebase-functions.js';
import { getApp } from 'https://www.gstatic.com/firebasejs/9.23.0/firebase-app.js';
import { increment, arrayUnion } from 'https://www.gstatic.com/firebasejs/9.23.0/firebase-firestore.js';
import { getUserProfile, saveUserProfile, getUserSongs, listenToUserProfile } from './firestore/firestoreService.js';
import { setIsAdmin } from './adminState.js';
import { log } from './logger.js';
import { setCurrentUserProfile, setCurrentUserSongs } from './userState.js';
import { clearProfileCache } from './userProfileCache.js';
import { useAppStore } from './store.js';
import { addNotification } from '../components/ezViewManager.js';
import { disablePushNotifications } from './pushNotifications.js';
import { loadAndApplyTheme, setThemeInitializationMode } from './ui/themeManager.js';


export const EMAIL_ACTION_URL = 'https://octave11.com/auth/action';

export const actionCodeSettings = {
    url: EMAIL_ACTION_URL,
    handleCodeInApp: false,
};


function isFlurboApp() {
    return typeof window.__JUCE__ !== 'undefined' || typeof window.flurboApp !== 'undefined';
}


function isFreshNavigation() {
    const navEntry = performance.getEntriesByType('navigation')[0];
    return navEntry && navEntry.type === 'navigate';
}


const FONT_OPTIONS = [
    { name: 'Street Art', family: 'Permanent Marker' },
    { name: 'Modern', family: 'Bangers' },
    { name: 'Artistic', family: 'Pacifico' },
    { name: 'Avant-Garde', family: 'Bebas Neue' },
    { name: 'Retro Gaming', family: 'Bungee Inline' },
    { name: 'Glitch Tech', family: 'Orbitron' },
    { name: 'Industrial', family: 'Electrolize' },
    { name: 'Classic Serif', family: 'Cinzel' },
    { name: 'Retro', family: 'Righteous' },
    { name: 'Cyber', family: 'Share Tech Mono' },
    { name: 'Kids', family: 'Indie Flower' },
    { name: 'Decorative', family: 'Lobster' }
];


function showProfileCompletionModal(defaultName = '') {
    return new Promise((resolve) => {
        
        const existingModal = document.getElementById('profile-completion-modal');
        if (existingModal) existingModal.remove();
        
        
        const fontGridHTML = FONT_OPTIONS.map((font, index) => `
            <button class="font-option font-square" data-font="${font.family}" data-name="${font.name}" title="${font.name}">
                <span class="font-number">${index + 1}</span>
            </button>
        `).join('');
        
        const modal = document.createElement('div');
        modal.id = 'profile-completion-modal';
        modal.innerHTML = `
            <div style="
                position: fixed;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background: rgba(0,0,0,0.9);
                display: flex;
                align-items: center;
                justify-content: center;
                z-index: 10000;
            ">
                <div style="
                    background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
                    border: 2px solid #8b5cf6;
                    border-radius: 16px;
                    padding: 32px;
                    max-width: 500px;
                    width: 90%;
                    box-shadow: 0 0 40px rgba(139, 92, 246, 0.3);
                ">
                    <h2 style="color: #fff; margin: 0 0 8px; font-size: 24px; text-align: center;">Choose Your Artist Name & Style</h2>
                    <p style="color: #9ca3af; margin: 0 0 24px; font-size: 14px; text-align: center;">This will be your identity on the platform</p>
                    
                    <div style="margin-bottom: 20px;">
                        <label style="color: #e5e7eb; font-size: 13px; display: block; margin-bottom: 8px;">Artist Name</label>
                        <input type="text" id="completion-name-input" 
                            placeholder="Enter your artist name..." 
                            value="${defaultName}"
                            maxlength="20"
                            style="width: 100%; padding: 12px 16px; background: #1f2937; border: 1px solid #374151; border-radius: 8px; color: #f3f4f6; font-size: 16px; outline: none; box-sizing: border-box;">
                    </div>
                    
                    <div style="margin-bottom: 20px;">
                        <label style="color: #e5e7eb; font-size: 13px; display: block; margin-bottom: 8px;">Preview</label>
                        <div id="completion-font-preview" style="
                            background: #1f2937;
                            border: 1px solid #374151;
                            border-radius: 8px;
                            padding: 20px;
                            text-align: center;
                            font-size: 28px;
                            color: #a78bfa;
                            min-height: 80px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                        ">${defaultName || 'Your Name'}</div>
                    </div>
                    
                    <div style="margin-bottom: 24px;">
                        <label style="color: #e5e7eb; font-size: 13px; display: block; margin-bottom: 12px;">Select a font style:</label>
                        <div style="display: grid; grid-template-columns: repeat(6, 1fr); gap: 8px;">
                            ${fontGridHTML}
                        </div>
                    </div>
                    
                    <div style="display: flex; gap: 12px;">
                        <button id="completion-cancel-btn" 
                            style="flex: 1; padding: 12px 24px; background: #374151; border: none; border-radius: 8px; color: #d1d5db; font-weight: 500; cursor: pointer; font-size: 16px;">
                            Cancel
                        </button>
                        <button id="completion-confirm-btn" 
                            style="flex: 1; padding: 12px 24px; background: #8b5cf6; border: none; border-radius: 8px; color: white; font-weight: 500; cursor: pointer; font-size: 16px;" disabled>
                            Continue
                        </button>
                    </div>
                </div>
            </div>
            
            <style>
                .font-square {
                    width: 40px;
                    height: 40px;
                    background: #1f2937;
                    border: 2px solid #374151;
                    border-radius: 8px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    transition: all 0.2s;
                }
                .font-square:hover {
                    border-color: #8b5cf6;
                }
                .font-square.selected {
                    border-color: #8b5cf6;
                    background: rgba(139, 92, 246, 0.2);
                }
                .font-number {
                    color: #9ca3af;
                    font-size: 12px;
                    font-weight: bold;
                }
            </style>
        `;
        
        document.body.appendChild(modal);
        
        const nameInput = document.getElementById('completion-name-input');
        const fontPreview = document.getElementById('completion-font-preview');
        const fontOptions = modal.querySelectorAll('.font-option');
        const confirmBtn = document.getElementById('completion-confirm-btn');
        const cancelBtn = document.getElementById('completion-cancel-btn');
        
        let selectedFont = FONT_OPTIONS[0].family;
        let selectedName = defaultName;
        
        
        fontOptions[0]?.classList.add('selected');
        fontPreview.style.fontFamily = selectedFont;
        
        
        setTimeout(() => nameInput?.focus(), 100);
        
        
        nameInput?.addEventListener('input', (e) => {
            selectedName = e.target.value.trim();
            fontPreview.textContent = selectedName || 'Your Name';
            confirmBtn.disabled = selectedName.length < 2;
        });
        
        
        fontOptions.forEach(option => {
            option.addEventListener('click', () => {
                fontOptions.forEach(opt => opt.classList.remove('selected'));
                option.classList.add('selected');
                selectedFont = option.dataset.font;
                fontPreview.style.fontFamily = selectedFont;
            });
        });
        
        
        confirmBtn.addEventListener('click', () => {
            if (selectedName.length >= 2) {
                modal.remove();
                resolve({ artistName: selectedName, fontFamily: selectedFont });
            }
        });
        
        
        cancelBtn.addEventListener('click', () => {
            modal.remove();
            resolve(null);
        });
        
        
        nameInput?.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' && selectedName.length >= 2) {
                confirmBtn.click();
            }
        });
    });
}


const loadingPhrases = [
    'Aligning the cosmos',
    'Feeding mutant chickens',
    'Overclocking the possums',
    'Defragmenting user patience',
    'Loading something cool hopefully',
    'Translating binary code into sarcasm',
    'Poking the restaurant server',
    'Buffering hyperspace',
    'Counting backwards from infinity',
    'Giving the dial-up modem a pep talk',
    'Painting the loading bar by hand',
    'Conceptualizing the perfect date night'
];

let loadingMessageInterval = null;
let lastLoadingMessageIndex = -1;

function getRandomLoadingPhrase() {
    let newIndex;
    do {
        newIndex = Math.floor(Math.random() * loadingPhrases.length);
    } while (newIndex === lastLoadingMessageIndex && loadingPhrases.length > 1);
    
    lastLoadingMessageIndex = newIndex;
    return loadingPhrases[newIndex];
}

function startLoadingMessageRotation() {
    const loadingMessage = document.getElementById('loading-message');
    if (!loadingMessage) return;
    
    
    stopLoadingMessageRotation();
    
    
    loadingMessage.textContent = getRandomLoadingPhrase();
    
    
    loadingMessageInterval = setInterval(() => {
        loadingMessage.textContent = getRandomLoadingPhrase();
    }, 1500);
}

function stopLoadingMessageRotation() {
    if (loadingMessageInterval) {
        clearInterval(loadingMessageInterval);
        loadingMessageInterval = null;
    }
}


const googleProvider = new GoogleAuthProvider();
const facebookProvider = new FacebookAuthProvider();
const appleProvider = new OAuthProvider('apple.com');


appleProvider.addScope('email');
appleProvider.addScope('name');

let onAuthStateChangedUnsubscribe = null;



const GUEST_SESSION_KEY = 'octave11_guest_session';


function isSharedLink() {
    const params = new URLSearchParams(window.location.search);
    
    const sharedParams = ['song', 'playlist', 'show', 'artist'];
    return sharedParams.some(p => params.has(p));
}


export function getGuestSession() {
    try {
        const data = sessionStorage.getItem(GUEST_SESSION_KEY);
        return data ? JSON.parse(data) : null;
    } catch (e) {
        return null;
    }
}


export function saveGuestSession(data) {
    sessionStorage.setItem(GUEST_SESSION_KEY, JSON.stringify({
        ...data,
        savedAt: Date.now()
    }));
}


export function clearGuestSession() {
    sessionStorage.removeItem(GUEST_SESSION_KEY);
}


function generateGuestName() {
    const numbers = Math.floor(1000 + Math.random() * 9000); 
    return `guest${numbers}`;
}


export function enterGuestMode() {
    console.log('[Guest Mode] Entering guest mode...');

    
    const sharedSongId = new URLSearchParams(window.location.search).get('song');
    if (sharedSongId) {
        console.log('[Guest Mode] Captured shared song link:', sharedSongId);
    }

    
    const loadingOverlay = document.getElementById('loading-overlay');
    const loadingMessage = document.getElementById('loading-message');
    if (loadingOverlay) loadingOverlay.classList.remove('hidden');
    if (loadingMessage) startLoadingMessageRotation();
    if (typeof window.logOctaveState === 'function') window.logOctaveState('guest-enter-start');

    let guestData = getGuestSession();
    
    
    let guestName = guestData?.guestName || generateGuestName();
    
    if (!guestData) {
        
        guestData = {
            coins: 0,
            tickets: 0,
            badges: [],
            playlists: [],
            earnedCoins: 0,
            earnedTickets: 0,
            earnedBadges: [],
            guestName: guestName
        };
    }
    
    
    useAppStore.getState().setIsGuest(true);
    useAppStore.getState().setGuestData(guestData);
    useAppStore.getState().setGuestName(guestName);
    
    
    const loginContainer = document.getElementById('login-container');
    const mainAppContainer = document.getElementById('main-app-container');
    
    if (loginContainer) loginContainer.classList.add('hidden');
    
    document.body.classList.add('guest-mode');
    
    
    setupGuestBeforeUnload();
    
    
    applyGuestTheme();
    
    
    initializeGuestUI(sharedSongId);
    
    console.log(`[Guest Mode] Guest mode activated with name: ${guestName}`);
}


async function initializeGuestUI(sharedSongId = null) {
    console.log('[Guest Mode] Initializing guest UI components...');

    const mainAppContainer = document.getElementById('main-app-container');
    const loadingOverlay = document.getElementById('loading-overlay');
    
    try {
        
        
        if (typeof window.initializeGuestApp === 'function') {
            window.initializeGuestApp();
        }
        
        
        const aiModule = await import('../components/aiCoPilot.js');
        aiModule.initializeAICoPilot();
        aiModule.sendInitialGreeting();
        
        
        const chatModule = await import('../components/chatConsoleManager.js');
        await chatModule.initializeChatConsole();
        window.switchChatMode = chatModule.switchMode;
        
        
        const { initializeConsoleTabs, restoreSplitView } = await import('../components/consoleManager.js');
        initializeConsoleTabs();
        
        
        restoreSplitView(true);
        
        
        const { initializeChatBanner } = await import('../components/chatBannerManager.js');
        initializeChatBanner();
        
        
        const { initNotificationsManager } = await import('./notificationsManager.js');
        initNotificationsManager();

        if (sharedSongId) {
            window._sharedSongId = sharedSongId;
            window._loadingSharedSong = true;
        }
        
        
        const { loadPlaylistPreferences } = await import('../components/playlistManager.js');
        await loadPlaylistPreferences();

        
        await handleSongLinkParameter(sharedSongId);

        
        const { initializeAnimations } = await import('../components/animationManager.js');
        initializeAnimations();
        
        
        const { initializeHeaderPointsManager } = await import('../components/headerPointsManager.js');
        initializeHeaderPointsManager();
        
        
        const { initializeHelpModeEventListeners } = await import('../components/helpModeManager.js');
        initializeHelpModeEventListeners();
        
        
        const { initializeSearchMode } = await import('../components/searchModeManager.js');
        initializeSearchMode();
        
        
        const { initializeSocialsWidget } = await import('../components/socialsWidget.js');
        initializeSocialsWidget();
        
        
        const { initializeUserStatus } = await import('../components/userStatusManager.js');
        initializeUserStatus(null);
        
        
        const { startPresenceListener } = await import('../components/sonic_lounge/presence.js');
        startPresenceListener();
        
        
        
        window.addEventListener('forceDefaultThemeReload', async () => {
            console.log('[Guest Mode] Received forceDefaultThemeReload event, reloading guest theme...');
            try {
                const { loadAndApplyTheme, setThemeInitializationMode } = await import('./ui/themeManager.js');
                setThemeInitializationMode(true);
                await loadAndApplyTheme({ preferences: { activeScheme: null } }); 
                setThemeInitializationMode(false);
            } catch (error) {
                console.error('[Guest Mode] Error reloading theme:', error);
            }
        });

        
        
        const params = new URLSearchParams(window.location.search);
        if (!params.has('song') || sessionStorage.getItem('processedSongId') === params.get('song')) {
            const { checkNewsOnStartup, checkConnectLiveOnStartup } = await import('../components/chatBannerManager.js');
            checkNewsOnStartup();
            checkConnectLiveOnStartup();
        }

        
        if (loadingOverlay) loadingOverlay.classList.add('hidden');
        if (mainAppContainer)
            setTimeout(() => { mainAppContainer.classList.remove('hidden'); mainAppContainer.style.removeProperty('display'); if (typeof window.logOctaveState === 'function') window.logOctaveState('guest-reveal-main'); }, 1050);
        stopLoadingMessageRotation();

        console.log('[Guest Mode] Guest UI initialization complete');
    } catch (error) {
        console.error('[Guest Mode] Error initializing guest UI:', error);
        if (loadingOverlay) loadingOverlay.classList.add('hidden');
        if (mainAppContainer) {
            mainAppContainer.classList.remove('hidden');
            mainAppContainer.style.removeProperty('display');
        }
    }
}


async function applyGuestTheme() {
    try {
        
        setThemeInitializationMode(true);
        
        
        const guestProfile = {
            preferences: {
                activeScheme: null 
            }
        };
        
        await loadAndApplyTheme(guestProfile);
        
        
        setThemeInitializationMode(false);
        
        console.log('[Guest Mode] Default theme applied');
    } catch (error) {
        console.error('[Guest Mode] Error applying theme, applying fallback:', error);
        setThemeInitializationMode(false);
        
        
        
        applyFallbackTheme();
    }
}


function applyFallbackTheme() {
    
    document.documentElement.style.setProperty('--color-frame', '#0a0a0f');
    document.documentElement.style.setProperty('--color-music-player-bg', '#0a0a0f');
    
    
    document.documentElement.style.setProperty('--color-windows-bg', '#1a1a2e');
    document.documentElement.style.setProperty('--color-chat-bubble-user-bg', '#27272a');
    document.documentElement.style.setProperty('--color-emoji-bar-bg', '#1a1a2e');
    document.documentElement.style.setProperty('--color-waveform-bg', '#1a1a2e');
    document.documentElement.style.setProperty('--color-queue-bg', '#8b5cf6');
    document.documentElement.style.setProperty('--color-carousel-bg', '#1a1a2e');
    
    
    document.documentElement.style.setProperty('--color-console-main', '#16213e');
    document.documentElement.style.setProperty('--color-playbar-accent-bg', '#16213e');
    document.documentElement.style.setProperty('--color-windows-inner-bg', '#16213e');
    document.documentElement.style.setProperty('--color-tertiary', '#16213e');
    document.documentElement.style.setProperty('--color-player-bg', '#16213e');
    
    
    document.documentElement.style.setProperty('--color-top-windows-bg', '#252545');
    document.documentElement.style.setProperty('--color-button-default-bg', '#252545');
    document.documentElement.style.setProperty('--color-icon-default', '#a0a0aa');
    
    
    document.documentElement.style.setProperty('--color-active-highlight', '#8b5cf6');
    
    console.log('[Guest Mode] Fallback theme applied');
}


export function exitGuestMode() {
    clearGuestSession();
    useAppStore.getState().setIsGuest(false);
    useAppStore.getState().setGuestData(null);
    useAppStore.getState().setGuestName(null);
    window.location.reload();
}


export async function transferGuestSessionToUser(userId) {
    const guestData = getGuestSession();
    if (!guestData) return;

    console.log('[Guest Mode] Transferring guest session to user:', userId);

    await saveUserProfile(userId, {
        guestCoins: increment(guestData.coins || 0),
        guestTickets: increment(guestData.tickets || 0),
        guestBadges: arrayUnion(...(guestData.badges || [])),
        guestPlaylists: arrayUnion(...(guestData.playlists || []))
    });

    clearGuestSession();

    console.log('[Guest Mode] Transfer complete');
}


export function updateGuestSession(updates) {
    const currentData = getGuestSession() || {};
    const newData = { ...currentData, ...updates };
    saveGuestSession(newData);
    useAppStore.getState().setGuestData(newData);
}


function setupGuestBeforeUnload() {
    window.addEventListener('beforeunload', (e) => {
        const isGuest = useAppStore.getState().isGuest;
        if (!isGuest) return;
        
        const guestData = getGuestSession();
        const hasProgress = guestData && (
            guestData.coins > 0 || 
            guestData.tickets > 0 || 
            guestData.badges.length > 0 || 
            guestData.playlists.length > 0
        );
        
        if (hasProgress) {
            
            if (sessionStorage.getItem('guest_confirmed_leave')) {
                return; 
            }
            
            
            e.preventDefault();
            e.returnValue = '';
            
            
            showGuestLeaveWarning();
        }
    });
}


function showGuestLeaveWarning() {
    
    const existingModal = document.getElementById('guest-leave-modal');
    if (existingModal) existingModal.remove();
    
    const modal = document.createElement('div');
    modal.id = 'guest-leave-modal';
    modal.innerHTML = `
        <div style="
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0,0,0,0.8);
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 10000;
        ">
            <div style="
                background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
                border: 2px solid #60a5fa;
                border-radius: 16px;
                padding: 32px;
                max-width: 400px;
                text-align: center;
                box-shadow: 0 0 40px rgba(96, 165, 250, 0.3);
            ">
                <div style="font-size: 48px; margin-bottom: 16px;">⚠️</div>
                <h2 style="color: #fff; margin: 0 0 16px; font-size: 24px;">Wait! Don't lose your progress</h2>
                <p style="color: #9ca3af; margin: 0 0 24px; font-size: 14px; line-height: 1.6;">
                    You'll lose everything you've earned as a guest:<br>
                    <span style="color: #fbbf24;">🪙 Coins</span> • 
                    <span style="color: #a78bfa;">🎫 Tickets</span> • 
                    <span style="color: #f472b6;">🏆 Badges</span> • 
                    <span style="color: #34d399;">📋 Playlists</span>
                </p>
                <div style="display: flex; flex-direction: column; gap: 12px;">
                    <button id="guest-signup-btn" style="
                        background: linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%);
                        color: white;
                        border: none;
                        padding: 14px 24px;
                        border-radius: 8px;
                        font-size: 16px;
                        font-weight: 600;
                        cursor: pointer;
                        transition: transform 0.2s;
                    ">Sign Up - Keep Everything</button>
                    <button id="guest-leave-btn" style="
                        background: transparent;
                        color: #9ca3af;
                        border: 1px solid #4b5563;
                        padding: 12px 24px;
                        border-radius: 8px;
                        font-size: 14px;
                        cursor: pointer;
                        transition: all 0.2s;
                    ">Leave Without Saving</button>
                </div>
            </div>
        </div>
    `;
    
    document.body.appendChild(modal);
    
    
    modal.querySelector('#guest-signup-btn').addEventListener('click', () => {
        sessionStorage.setItem('guest_confirmed_leave', 'true');
        modal.remove();
        
        if (window.handleShowSignup) {
            window.handleShowSignup();
        } else {
            
            const guestData = getGuestSession() || {};
            localStorage.setItem('pendingGuestTransfer', JSON.stringify(guestData));
            window.location.href = 'https://octave11.com?signup=1&from=guest';
        }
    });
    
    
    modal.querySelector('#guest-leave-btn').addEventListener('click', () => {
        sessionStorage.setItem('guest_confirmed_leave', 'true');
        modal.remove();
        
        window.location.href = 'https://octave11.com';
    });
}


window._authHelpers = {
    signInWithGoogle,
    signInWithEmail,
    signUpWithEmail
};

export function checkLoginStatusAndDisplayUI(auth, onUserReady) {
    const loadingOverlay = document.getElementById('loading-overlay');
    const loadingMessage = document.getElementById('loading-message');
    const loginContainer = document.getElementById('login-container');
    const mainAppContainer = document.getElementById('main-app-container');

    if (onAuthStateChangedUnsubscribe) onAuthStateChangedUnsubscribe();

    
    window._authInstance = auth;

    
    getRedirectResult(auth)
        .then((result) => {
            if (result && result.user) {
                console.log('[Auth] Redirect result user:', result.user.uid);
            }
        })
        .catch((error) => {
            console.error('[Auth] Redirect result error:', error);
        });

    
    let authHandled = false;
    
    onAuthStateChangedUnsubscribe = auth.onAuthStateChanged(async (user) => {
        console.log('[Auth] onAuthStateChanged callback - user:', user ? user.uid : null);
        loadingOverlay.classList.remove('hidden');
        startLoadingMessageRotation();
        if (typeof window.logOctaveState === 'function') window.logOctaveState('auth-show-loading');

        if (user) {
            
            authHandled = true; 
            try {
                
                useAppStore.getState().setIsGuest(false);
                useAppStore.getState().setGuestData(null);
                useAppStore.getState().setGuestName(null);

                
                document.body.classList.remove('guest-mode');

                
                const wasGuest = sessionStorage.getItem('guest_just_signed_up');
                if (wasGuest) {
                    sessionStorage.removeItem('guest_just_signed_up');
                    
                    await transferGuestSessionToUser(user.uid);
                }

                const idTokenResult = await user.getIdTokenResult();
                setIsAdmin(!!idTokenResult.claims.admin);
                
                
                window.dispatchEvent(new CustomEvent('userLoggedIn'));

                let userProfile = await getUserProfile(user.uid, { forceServer: true });
                if (!userProfile || !userProfile.artistName) {
                    
                    const defaultName = user.displayName || user.email?.split('@')[0] || '';
                    const profileData = await showProfileCompletionModal(defaultName);
                    
                    if (!profileData) {
                        
                        await signOut(auth);
                        return;
                    }
                    
                    
                    const { getDefaultColorScheme } = await import('./firestore/firestoreCustomization.js');
                    const defaultTheme = await getDefaultColorScheme();
                    
                    const newUserProfile = {
                        artistName: profileData.artistName,
                        username: profileData.artistName.toLowerCase().replace(/\s+/g, ''),
                        preferredFont_name: profileData.fontFamily,
                        email: user.email,
                        profilePicUrl: user.photoURL,
                        createdAt: new Date(),
                        
                        preferences: {
                            activeScheme: defaultTheme || null
                        }
                    };
                    await saveUserProfile(user.uid, newUserProfile);
                    userProfile = await getUserProfile(user.uid);
                }
                
                setCurrentUserProfile(userProfile);

                
                const { loadAndApplyTheme, setThemeInitializationMode } = await import('./ui/themeManager.js');
                
                
                setThemeInitializationMode(true);
                await loadAndApplyTheme(userProfile);
                
                setThemeInitializationMode(false);
                
                
                const userSongs = await getUserSongs(user.uid);
                setCurrentUserSongs(userSongs);
                
                
                listenToUserProfile(user.uid);
                
                
                checkSongsNeedingDetails(userSongs);
                
                
                const dismissedArt = userProfile?.preferences?.dismissedArtSuggestions || [];
                const songNeedingArt = userSongs.find(song => !song.albumArtUrl && !dismissedArt.includes(song.id));
                if (songNeedingArt) {
                    
                    window._pendingArtSuggestion = {
                        songId: songNeedingArt.id,
                        songTitle: songNeedingArt.title
                    };
                }
                
                log.info(`User logged in: ${userProfile.artistName || user.displayName} (UID: ${user.uid}), Is Admin: ${!!idTokenResult.claims.admin}`);
                
                const { connectToPresenceSystem } = await import('../components/sonic_lounge/presence.js');
                connectToPresenceSystem();

                loginContainer.classList.add('hidden');

                const sharedSongId = new URLSearchParams(window.location.search).get('song');
                if (sharedSongId) {
                    window._sharedSongId = sharedSongId;
                    window._loadingSharedSong = true;
                }

                if (onUserReady) {
                    await onUserReady(user, userProfile);
                }

                
                const { initNotificationsManager } = await import('./notificationsManager.js');
                initNotificationsManager();

                await handleSongLinkParameter();

                
                const loadedSongId = useAppStore.getState().currentLoadedSongId;
                if (loadedSongId) {
                    try {
                        const { getSongById } = await import('./firestore/firestoreService.js');
                        const { updatePlayerLikesCount } = await import('../components/audioPlayback.js');
                        const currentSong = await getSongById(loadedSongId);
                        if (currentSong) {
                            updatePlayerLikesCount(currentSong, user.uid);
                        }
                    } catch (err) {
                        console.warn('[Auth] Failed to refresh like state for current song:', err);
                    }
                }

                stopLoadingMessageRotation();
                loadingOverlay.classList.add('hidden');
                if (typeof window.logOctaveState === 'function') window.logOctaveState('auth-hide-loading');
                setTimeout(() => { mainAppContainer.classList.remove('hidden'); mainAppContainer.style.removeProperty('display'); if (typeof window.logOctaveState === 'function') window.logOctaveState('auth-reveal-main'); }, 1050);

                
                
                const params = new URLSearchParams(window.location.search);
                if (!params.has('song') || sessionStorage.getItem('processedSongId') === params.get('song')) {
                    const { checkNewsOnStartup, checkConnectLiveOnStartup } = await import('../components/chatBannerManager.js');
                    checkNewsOnStartup();
                    checkConnectLiveOnStartup();
                }
            } catch (error) {
                authHandled = false; 
                log.error("Error during login process:", error);
                stopLoadingMessageRotation();
            }
        } else {
            
            clearProfileCache();
            
            const wasIntentionalLogout = sessionStorage.getItem('intentional_logout');
            if (wasIntentionalLogout) {
                authHandled = true;
                sessionStorage.removeItem('intentional_logout');
                loginContainer.classList.remove('hidden');
                mainAppContainer.classList.add('hidden');
                loadingOverlay.classList.add('hidden');
                return;
            }
            
            
            
            console.log('[Auth] No user - entering guest mode');
            loadingOverlay.classList.add('hidden');
            enterGuestMode();
            authHandled = true;
            return;
        }
    });
}


export async function signInWithGoogle(auth) {
    const provider = new GoogleAuthProvider();
    try {
        if (isFlurboApp()) {
            console.log('[Auth] Using redirect sign-in for embedded app');
            await signInWithRedirect(auth, provider);
        } else {
            await signInWithPopup(auth, provider);
        }
    } catch (error) {
        
        if (error.code === 'auth/cancelled-popup-request' || error.code === 'auth/popup-blocked') {
            console.log('[Auth] Google sign-in cancelled or blocked by user - this is normal');
            return;
        }
        log.error("Google Sign-In Error", error);
        alert("Could not sign in with Google. Please try again.");
    }
}

export async function signInWithFacebook(auth) {
    try {
        if (isFlurboApp()) {
            console.log('[Auth] Using redirect sign-in for embedded app');
            await signInWithRedirect(auth, facebookProvider);
        } else {
            await signInWithPopup(auth, facebookProvider);
        }
    } catch (error) {
        log.error("Facebook Sign-In Error", error);
        alert("Could not sign in with Facebook. Please try again.");
    }
}

export async function signInWithApple(auth) {
    try {
        if (isFlurboApp()) {
            console.log('[Auth] Using redirect sign-in for embedded app');
            await signInWithRedirect(auth, appleProvider);
        } else {
            await signInWithPopup(auth, appleProvider);
        }
    } catch (error) {
        log.error("Apple Sign-In Error", error);
        alert("Could not sign in with Apple. Please try again.");
    }
}

export async function signInWithEmail(auth, email, password) {
    try {
        await signInWithEmailAndPassword(auth, email, password);
    } catch (error) {
        log.error("Email Sign-In Error", error);
        throw error; 
    }
}

export async function signUpWithEmail(auth, email, password) {
    try {
        const userCredential = await createUserWithEmailAndPassword(auth, email, password);
        
        await sendEmailVerification(userCredential.user, actionCodeSettings);
        log.info("Email verification sent to new user");
    } catch (error) {
        log.error("Email Sign-Up Error", error);
        throw error; 
    }
}

export async function signOutUser(auth) {
    try {
        const { disconnectFromPresenceSystem } = await import('../components/sonic_lounge/presence.js');
        disconnectFromPresenceSystem();

        try {
            await disablePushNotifications();
        } catch (pushErr) {
            console.warn('[Auth] Failed to disable push on sign out:', pushErr);
        }
        
        clearGuestSession();
        
        clearProfileCache();
        useAppStore.getState().setIsGuest(false);
        useAppStore.getState().setGuestData(null);
        useAppStore.getState().setGuestName(null);
        
        sessionStorage.setItem('intentional_logout', 'true');
        await signOut(auth);
        
        window.location.href = 'https://octave11.com';
    } catch (error) {
        log.error("Sign Out Error", error);
    }
}


async function checkSongsNeedingDetails(userSongs) {
    if (!userSongs || userSongs.length === 0) return;
    
    
    const songsNeedingGenre = userSongs.filter(song => 
        song.albumArtUrl && (!song.genres || song.genres.length === 0)
    );
    
    
    const songsNeedingDetails = userSongs.filter(song => 
        !song.description || !song.tags || song.tags.length === 0
    );
    
    
    if (songsNeedingGenre.length > 0) {
        window._pendingSongsNeedingGenre = songsNeedingGenre;
        console.log('[DEBUG] Found songs needing genre:', songsNeedingGenre.map(s => s.title));
    }
    
    if (songsNeedingDetails.length > 0) {
        
        window._pendingSongsNeedingDetails = songsNeedingDetails;
        console.log('[DEBUG] Found songs needing details:', songsNeedingDetails.map(s => s.title));
        
        
        const songTitles = songsNeedingDetails.map(s => `"${s.title}"`).join(', ');
        import('../components/ezViewManager.js').then(({ addNotification }) => {
            addNotification(`Your songs need attention: ${songsNeedingDetails.length} song(s) missing description or tags. Open Jukebot to add them!`, { 
                type: 'info', 
                duration: 8000 
            });
        });
    }
}


async function handleSongLinkParameter(explicitSongId = null) {
    const songId = explicitSongId || new URLSearchParams(window.location.search).get('song');

    if (!songId) return;

    console.log('[Auth] Found song link parameter:', songId);

    const freshNavigation = isFreshNavigation();
    const alreadyProcessed = sessionStorage.getItem('processedSongId') === songId;
    const currentLoadedSongId = useAppStore.getState().currentLoadedSongId;
    if (alreadyProcessed && currentLoadedSongId === songId && window._sharedSongLoaded) {
        console.log('[Auth] Song link already loaded this session, skipping');
        window._loadingSharedSong = false;
        return;
    }

    window._loadingSharedSong = true;
    window._sharedSongLoaded = false;
    sessionStorage.setItem('processedSongId', songId);
    
    try {
        const { getSongById } = await import('./firestore/firestoreService.js');
        const { updateMusicPlayerUI } = await import('../components/playerVisuals.js');
        const { setPlaylistMode } = await import('../components/playlistManager.js');
        
        const song = await getSongById(songId);
        if (!song) {
            console.warn('[Auth] Song not found:', songId);
            window._loadingSharedSong = false;
            return;
        }
        
        console.log('[Auth] Loading shared song:', song.title);

        window._sharedSongId = songId;

        const isMobile = window.innerWidth <= 768;
        const freshNavigation = isFreshNavigation();
        if (isMobile && freshNavigation && !alreadyProcessed) {
            document.body.classList.remove('mobile-view-console', 'mobile-view-screen', 'mobile-view-song', 'mobile-view-artist');
            document.body.classList.add('mobile-view-song');

            
            const songNavBtn = document.querySelector('.mobile-nav-btn[data-view="song"]');
            if (songNavBtn) {
                document.querySelectorAll('.mobile-nav-btn').forEach(b => b.classList.remove('active'));
                songNavBtn.classList.add('active');
            }

            console.log('[Auth] Switched to mobile song view for fresh song link');
        }

        useAppStore.setState({
            currentLoadedSongId: song.id,
            currentArtistId: song.userId || null
        });

        await setPlaylistMode('ARTIST');

        const isGuest = useAppStore.getState().isGuest;
        const autoplayOnStartup = !isGuest && localStorage.getItem('autoplayOnStartup') === 'true';
        const shouldPlay = freshNavigation && !alreadyProcessed && (isGuest || autoplayOnStartup);

        await updateMusicPlayerUI(song, { shouldPlay, isManualPlay: freshNavigation && !alreadyProcessed, skipPlaylistUpdate: true });

        if (isMobile && freshNavigation && !alreadyProcessed) {
            try {
                const { syncMobilePlayQueuePlacement, syncMobileWaveformPlacement, syncMobileAlbumArtPlacement } = await import('../components/consoleManager.js');
                syncMobilePlayQueuePlacement();
                syncMobileWaveformPlacement();
                syncMobileAlbumArtPlacement();
            } catch (err) {
                console.warn('[Auth] Error syncing mobile layout:', err);
            }
        }

        window._sharedSongLoaded = true;
        console.log('[Auth] Shared song loaded successfully:', song.title);
        
    } catch (error) {
        console.error('[Auth] Error loading song from link:', error);
    } finally {
        window._loadingSharedSong = false;
    }
}

export async function handleEmailAction(auth) {
    if (typeof window === 'undefined') return;
    const params = new URLSearchParams(window.location.search);
    const mode = params.get('mode');
    const oobCode = params.get('oobCode');
    if (!mode || !oobCode) return;

    try {
        if (mode === 'resetPassword') {
            const accountEmail = await verifyPasswordResetCode(auth, oobCode);
            const newPassword = window.prompt(`Enter a new password for ${accountEmail}`);
            if (!newPassword) {
                addNotification('Password reset cancelled.', { type: 'alert' });
                return;
            }
            if (newPassword.length < 6) {
                addNotification('Password must be at least 6 characters.', { type: 'alert' });
                return;
            }
            await confirmPasswordReset(auth, oobCode, newPassword);
            addNotification('Password reset successful. Please sign in.', { type: 'success' });
        } else if (mode === 'verifyEmail' || mode === 'recoverEmail' || mode === 'verifyAndChangeEmail') {
            await applyActionCode(auth, oobCode);
            if (auth.currentUser) {
                await auth.currentUser.reload();
            }
            addNotification('Email verified successfully.', { type: 'success' });
        } else {
            addNotification('Unknown email action.', { type: 'alert' });
            return;
        }

        setTimeout(() => window.location.replace('/'), 1500);
    } catch (error) {
        console.error('[handleEmailAction] Error handling email action:', error);
        addNotification('Email action failed or the link expired.', { type: 'alert' });
    }
}
